import { CreateTicketBrandings } from "@copetence/shared";
import { classes } from "handlers/StyleHandler";
import { useAppContext } from "providers/ContextProvider";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import LindeLogo from "../../assets/LindeLogoFull.png";
import JRCLogo from "../../assets/alto-partners.png";
import CopetenceLogo from "../../assets/coPetence_Logo_White.svg";
import LFLogo from "../../assets/leaseforce-ch-logo.svg";
import s from "./header.module.scss";

const Header: React.FC = () => {

    const { hideHeader, branding } = useAppContext();
    const { t, i18n } = useTranslation();

    const fullWidthPaths = ["/ls"];
    const [headerType, setHeaderType] = React.useState<'fullWidth' | 'containered'>("containered");


    useEffect(() => {
        if (fullWidthPaths.includes(window.location.pathname)) {
            setHeaderType("fullWidth");
        } else {
            setHeaderType("containered");
        }
    }, [window.location.pathname]);

    if (hideHeader) return null;

    return (
        <header
            className={classes(
                s.header,
                s[headerType],
                branding === CreateTicketBrandings.COPETENCE ? s.leftAligned : ""
            )}
        >
            <div className={s.container}>
                <div className={s.logo}>
                    <BrandedLogo />
                </div>
            </div>
        </header>
    );
};

const BrandedLogo = () => {
    
    const {
        branding,
    } = useAppContext();

    if (branding === CreateTicketBrandings.LINDE) return (
        <img src={LindeLogo} alt="Logo" />
    )

    if (branding === CreateTicketBrandings.LEASEFORCE) return (
        <img src={LFLogo} alt="Logo" />
    )

    if (branding === CreateTicketBrandings.JRC) return (
        <img src={JRCLogo} alt="Logo" />
    )

    return <img src={CopetenceLogo} alt="Logo" style={{
        maxWidth: "220px",
    }} />;
}

export default Header;